import { render, staticRenderFns } from "./media-kit.vue?vue&type=template&id=249c63e1"
import script from "./media-kit.vue?vue&type=script&lang=js"
export * from "./media-kit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./media-kit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCard: require('/vercel/path0/components/ui/BaseCard.vue').default,PhoneNumber: require('/vercel/path0/components/micro/PhoneNumber.vue').default,EmailAddress: require('/vercel/path0/components/micro/EmailAddress.vue').default})
